import Axios from 'axios'
import router from '@/router'
import Vue from 'vue'
import store from '@/store'
import types from '@/store/types'
import appConfig from '@/config'

export const axios = Axios.create({
  baseURL: '/',
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

axios.interceptors.response.use(
  resp => {
    return Promise.resolve(resp)
  },
  res => {
    let response = res.response
    if (response && response.status === 504) {
      return Promise.resolve({ res, data: { code: 504, message: '请求超时' } })
    }
    if (response && response.status === 404) {
      return Promise.resolve({
        res,
        data: { code: 404, message: '请求地址不在了哈' }
      })
    }
    return Promise.reject(res)
  }
)

// export const CancelToken = Axios.CancelToken

export const handleResponse = resp => {
  return new Promise((resolve, reject) => {
    const data = resp.data
    if (!data) {
      reject(
        createError(
          400,
          '没有数据返回，不满足规范要求，请让后端检测接口返回参数'
        )
      )
      return
    }
    if (resp.data.code === 504) {
      Vue.prototype.$notify.error({
        title: '错误',
        message: '请求超时',
        duration: 3000
      })
      reject(createError(504, '请求超时'))
      return
    }
    if (resp.data.code === 401) {
      store
        .dispatch(types.user.LOGOUT)
        .then(() => {
          Vue.prototype.$notify.info({
            title: '提示',
            message: '会话已过期，请重新登录',
            duration: 0
          })
          if (appConfig.tagNavList.logoutClearList) {
            let list = store.state.app.tagNavList
            let res = list.filter(item => item.name === 'home')
            store.dispatch('setTagNavList', res).then(() => {
              router.replace({ path: '/login' })
            })
          } else {
            router.replace({ path: '/login' })
          }
        })
        .catch(err => {
          console.error(err)
          reject(createError(500, '登出失败，服务器内部错误'))
        })
      // api('base/logout')().then(() => {
      //   if (data.success) router.replace({path: '/login'})
      //   else resolve()
      // }).catch(() => {
      //   reject(createError(500, '登出失败，服务器内部错误'))
      // })
      return
    }
    if (resp.data.code === 404) {
      Vue.prototype.$notify.error({
        title: '错误',
        message: resp.data.message,
        duration: 3000
      })
      reject(createError(404, resp.data.message))
      return
    }
    if (resp.data.code === 400) {
      Vue.prototype.$notify.error({
        title: '错误',
        // set: resp.data.set ? resp.data.set : 'Bad Request',
        message: 'Bad Request',
        duration: 3000
      })
      reject(createError(400, 'Bad Request'))
      return
    }
    if (resp.data.code === 403) {
      Vue.prototype.$notify.warning({
        title: '警告',
        message: resp.data.message ? resp.data.message : '权限不足',
        duration: 3000
      })
      reject(createError(403, '权限不足'))
      return
    }
    if (data.success !== undefined && !data.success) {
      reject(createError(500, data.msg, data.data))
      return
    }
    resolve(data.data ? data.data : data)
  })
}

// 不需要
export const injectCookies = () => {}

export const createError = (code, message, data = {}) => {
  let err = new Error(message)
  err.code = code
  err.msg = message
  err.data = data

  return err
}



// WEBPACK FOOTER //
// ./src/api/axios.js